"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var export_modal_html_1 = __importDefault(require("./export-modal.html"));
require("./export-modal.less");
(function (module) {
    'use strict';
    module.factory('prEeExportModal', [
        'qstrap.modal',
        function (modal) {
            return {
                show: function show() {
                    return modal({
                        show: true,
                        controller: 'prEeExportModalController',
                        title: '<span translate>EXPORT_REPORT</span>',
                        contentTemplate: export_modal_html_1.default,
                        buttons: [
                            '<button class="btn btn-primary" ng-click="close() && $ctrl.download()" ' +
                                '<span translate>EXPORT_REPORT</span></button>',
                            '<button class="btn btn" ng-click="close()" ' +
                                '<span translate>CANCEL</span></button>'
                        ]
                    });
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
